import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import TagManager from 'react-gtm-module';
import App from './App';
import { setupStore } from './store/store';
import './i18n';
import { googleClientId, googleTMId } from './constants/configuration';
import { initFirebaseAnalytics } from './services/firebase/firebase';

const store = setupStore();

const tagManagerArgs = {
  gtmId: googleTMId,
};

if (tagManagerArgs.gtmId) {
  TagManager.initialize(tagManagerArgs);
}

initFirebaseAnalytics();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={googleClientId}>
        <Suspense fallback="">
          <App />
        </Suspense>
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
